export const Bio = {
  name: "Mohammad Qasim",
  roles: ["Full Stack Developer", "Java Developer", "Programmer"],
  description:
    "Driven Final-year engineering student with a passion for technology, seeking to make a positive impact on the world through software development. Leveraging strong problem-solving skills, I am dedicated to personal growth and actively contributing to innovative projects in the field.",
  github: "https://github.com/qasimk02",
  resume:
    "https://drive.google.com/file/d/1pWwKmsiVT0v6mmQXPJjBWbs02ZcVwQzf/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/mohammad-qasim-9ba96120a/",
  twitter: "#",
  insta: "#",
  facebook: "#",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Spring",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/spring/spring-original.svg",
      },
      {
        name: "Spring Boot",
        image:
          "https://dz2cdn1.dzone.com/storage/temp/12434118-spring-boot-logo.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Node Js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express Js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
      },
      {
        name: "C",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
      },
      {
        name: "CPP",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Eclipse",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/eclipse/eclipse-original.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postman/postman-original.svg",
      },
      {
        name: "Figma",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "DevOps & Fullstack Engineering Intern",
    company: "Flipr Inovations Pvt. Ltd.",
    date: "Aug 2023 - July 2023",
    desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Portainer",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
];

export const education = [
  {
    id: 0,
    img: "https://tse4.mm.bing.net/th?id=OIP.qigHIHsXp55eQ4kUWFB9qgAAAA&pid=Api&P=0&h=180",
    school: "Xavier Institute of Engineering",
    date: "Oct 2020 - June 2024",
    grade: "8.81 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Electronics and Telecommunications at Xavier Institute of Engineering, Mahim, Mumbai. Having completed six semesters with a CGPA of 8.81, I have undertaken courses in Database Management Systems, Computer Networks, and Data Structures and Algorithms, among others. As the Head of Software and Hackathon at Transmission Fest, I acquired leadership and management skills. Additionally, I volunteered in the TEDxXIE Publicity Team, developing valuable skills in event promotion, communication, and team collaboration.",
    degree: "Bachelor of Engineering - BE, Electronics and Telecommunications",
  },
  {
    id: 1,
    img: "https://tse4.mm.bing.net/th?id=OIP.sFStESgaD1tK_5xinqpTnAHaHa&pid=Api&P=0&h=180",
    school: "Xavier's High School",
    date: "Apr 2016 - Apr 2018",
    grade: "78.2%",
    desc: "I completed my class 12 education at Xavier's High School Ailwal Azamgarh, where I studied Science with PCM(Physics,Chemestry and Mathematics)",
    degree: "CBSE(XII), PCM",
  },
  {
    id: 2,
    img: "https://tse4.mm.bing.net/th?id=OIP.lxb3VMHM5i3_B4euiXCCfQHaHa&pid=Api&P=0&h=180",
    school: "St Joseph High School",
    date: "Apr 2014 - Apr 2016",
    grade: "77.9%",
    desc: "I completed my class 10 education at St Joseph High School Lahkhanpur Jaunpur, where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 0,
    title: "Zesty Ecommerce App",
    date: "Apr 2023 - Nov 2023",
    description:
      "A dynamic e-commerce web application featuring a suite of RESTful APIs for efficient management of products, categories, cart, users, admin, orders, reviews, and ratings. Ensured a secure environment with role-based authentication using Spring Security and JWT, while seamlessly integrating Razorpay for smooth payment transactions. The application boasts user-centric features like product rating, reviewing, and advanced search and filtering capabilities. The visually appealing and consistent UI design, crafted with Material UI and Tailwind CSS, enhances the overall user experience, making it an exemplary showcase of my skills in creating robust and user-friendly e-commerce solutions.",
    image:
      "https://github.com/qasimk02/zesty-ecom-frontend/raw/develop/readme-assets/zestyHomepage.PNG",
    tags: [
      "Java",
      "Javascript",
      "Spring Boot",
      "Spring Security",
      "React",
      "Redux",
      "MUI",
      "Tailwind Css",
      "JWT",
      "AWS",
    ],
    category: "web app",
    github: "https://github.com/qasimk02/zesty-ecom-backend",
    webapp: "https://zestyfal.netlify.app/",
  },
  {
    id: 1,
    title: "TechBook",
    date: "Apr 2022 - May 2022",
    description:
      "A Blogging website, meticulously crafted with JSP, Servlet, MySQL, and Bootstrap,  providing users with a dynamic space to share their thoughts across diverse categories .This dynamic application seamlessly integrates user-generated content across specified categories. With a responsive design facilitated by Bootstrap, users can effortlessly engage with the platform on any device. Beyond mere blogging, interactive features like comments and likes foster a sense of community, making this app a vibrant space for discussions. This project stands as a testament to my proficiency in combining cutting-edge technologies to create a professional and engaging web solution. ",
    image:
      "https://raw.githubusercontent.com/qasimk02/TechBook/master/readme-assets/blogPage.PNG",
    tags: [
      "Java",
      "JSP",
      "Servlet",
      "MySql",
      "JDBC",
      "JavaScript",
      "Bootstrap",
    ],
    category: "web app",
    github: "https://github.com/qasimk02/TechBook",
    webapp: "https://github.com/qasimk02/TechBook",
  },
  {
    id: 2,
    title: "FACE DETECTIFY",
    date: "Apr 2021 - May 2021",
    description:
      "Developed a dynamic and secure face detection web application using a tech stack comprising React, NodeJS, and Express JS. Implemented a robust user authentication system, enabling users to create accounts, log in, and log out securely. The user-friendly React interface allows seamless image uploads for face detection. Leveraged PostgreSQL for efficient data management, storing and tracking the number of image entries in the database. A successful integration with the Clarifai API enhances the app's facial recognition capabilities. This project demonstrates my proficiency in full-stack development, user authentication, and seamless API integration.",
    image:
      "https://raw.githubusercontent.com/qasimk02/face-detectify-frontend/develop/readme-assets/faceDetectifyHome.PNG",
    tags: [
      "React",
      "Node JS",
      "Express JS",
      "PostgreSql",
      "Clarifi API",
      "CSS",
      "Javascript",
    ],
    category: "machine learning",
    github: "https://github.com/qasimk02/face-detectify-frontend",
    webapp: "https://github.com/qasimk02/face-detectify-frontend",
  },
  {
    id: 2,
    title: "SERCUIT",
    date: "Sep 2022 - Jan 2023",
    description:
      "A web-based IOT application that seamlessly integrates Raspberry Pi, STM32, and a WiFi module to transmit device data seamlessly to a backend built on Python Flask and PostgreSQL. The project featured a secure React-based web app with real-time data visualization and dynamic charting for efficient monitoring and analysis, showcasing my skills in hardware integration, software development, and end-to-end solution creation",
    image:
      "https://raw.githubusercontent.com/qasimk02/Sercuit-IOT-Based-Industry-Protection-System/master/readme-assets/dashboard.png",
    tags: [
      "Raspberry Pi",
      "Python",
      "Flask",
      "React",
      "Javascript",
      "Css",
      "Wifi Module",
    ],
    category: "iot",
    github:
      "https://github.com/qasimk02/Sercuit-IOT-Based-Industry-Protection-System",
    webapp:
      "https://github.com/qasimk02/Sercuit-IOT-Based-Industry-Protection-System",
    member: [
      {
        name: "Mohammad Qasim",
        img: "https://raw.githubusercontent.com/qasimk02/Sercuit-IOT-Based-Industry-Protection-System/master/frontend/public/images/qasim.png",
        linkedin: "https://www.linkedin.com/in/mohammad-qasim-9ba96120a/",
        github: "https://github.com/qasimk02",
      },
      {
        name: "Sudesh Manjrekar",
        img: "https://raw.githubusercontent.com/qasimk02/Sercuit-IOT-Based-Industry-Protection-System/master/frontend/public/images/sudesh.jpeg",
        linkedin: "https://www.linkedin.com/in/sudesh22/",
        github: "https://github.com/Sudesh22",
      },
    ],
  },
  {
    id: 4,
    title: "TIC TAC TOE",
    date: "June 2021 - July 2021",
    description:
      "Created a responsive 2-player Tic Tac Toe game using HTML, CSS, and JavaScript, showcasing meticulous design and implementation. Focused on optimal user experience, the project involved careful calculations and precise DOM manipulation. The result is an engaging and seamless web game, demonstrating technical proficiency and a commitment to clean, efficient code. This project reflects a dedication to delivering a polished, user-centric product within a compact and responsive framework.",
    image:
      "https://raw.githubusercontent.com/qasimk02/Tic-tac-toe-game/master/readme-assets/gameWin.PNG",
    tags: ["Html", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/qasimk02/Tic-tac-toe-game",
    webapp: "https://master--tic-tac-toe-game-qasim.netlify.app/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
